import React, { useEffect, useMemo } from 'react';
import { GlobalStyles } from '@mui/material';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';

const globalPopupStyles = {
  'body.experimental-popups .MuiBackdrop-root': {
    backgroundColor: 'rgba(15, 23, 42, 0.48)',
    backdropFilter: 'blur(7px)',
  },
  'body.experimental-popups .MuiDialog-paper': {
    overflow: 'hidden',
    border: '1px solid rgba(226, 232, 240, 0.9)',
    borderRadius: '26px !important',
    backgroundColor: '#ffffff',
    backgroundImage: 'linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)',
    boxShadow: '0 28px 90px rgba(15, 23, 42, 0.24)',
  },
  'body.experimental-popups .MuiDialogTitle-root': {
    position: 'relative',
    padding: '24px 26px 16px',
    color: '#1e293b',
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.2rem',
    fontWeight: '800 !important',
    letterSpacing: '-0.025em',
  },
  'body.experimental-popups .MuiDialogTitle-root::before': {
    position: 'absolute',
    top: 0,
    right: 26,
    left: 26,
    height: 4,
    borderRadius: '0 0 99px 99px',
    background: 'linear-gradient(90deg, #667eea, #764ba2, #f093fb)',
    content: '""',
  },
  'body.experimental-popups .MuiDialogContent-root': {
    padding: '16px 26px 24px',
    color: '#475569',
  },
  'body.experimental-popups .MuiDialogContent-dividers': {
    borderColor: '#eef2f7',
  },
  'body.experimental-popups .MuiDialogActions-root': {
    gap: '8px',
    margin: 0,
    padding: '14px 26px 20px !important',
    borderTop: '1px solid #eef2f7',
    background: '#f8fafc',
  },
  'body.experimental-popups .MuiDialogActions-root .MuiButton-root': {
    minHeight: 42,
    paddingRight: 18,
    paddingLeft: 18,
    borderRadius: '12px',
    fontWeight: 800,
    textTransform: 'none',
  },
  'body.experimental-popups .MuiDialogActions-root .MuiButton-contained': {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    boxShadow: '0 9px 20px rgba(102, 126, 234, 0.25)',
  },
  'body.experimental-popups .MuiOutlinedInput-root': {
    borderRadius: '13px',
    background: '#f8fafc',
  },
  'body.experimental-popups .MuiOutlinedInput-root fieldset': {
    borderColor: '#e2e8f0',
  },
  'body.experimental-popups .MuiOutlinedInput-root:hover fieldset': {
    borderColor: '#c7d2fe',
  },
  'body.experimental-popups .MuiOutlinedInput-root.Mui-focused fieldset': {
    borderColor: '#667eea',
    borderWidth: '1px',
  },
  'body.experimental-popups .MuiTabs-root': {
    minHeight: 42,
    padding: 3,
    border: '1px solid #e2e8f0',
    borderRadius: '13px',
    background: '#f8fafc',
  },
  'body.experimental-popups .MuiTab-root': {
    minHeight: 36,
    borderRadius: '10px',
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '0.72rem',
    fontWeight: 800,
    textTransform: 'none',
  },
  'body.experimental-popups .MuiTab-root.Mui-selected': {
    background: '#ffffff',
    color: '#4f46e5',
    boxShadow: '0 5px 14px rgba(15, 23, 42, 0.08)',
  },
  'body.experimental-popups .MuiTabs-indicator': {
    display: 'none',
  },
  'body.experimental-popups .ai-food-analyzer-dialog .MuiDialog-paper': {
    maxWidth: '980px',
  },
  'body.experimental-popups .ai-food-analyzer-header': {
    position: 'relative',
    padding: '24px 26px !important',
    background: 'linear-gradient(135deg, #4f46e5 0%, #667eea 52%, #764ba2 100%) !important',
  },
  'body.experimental-popups .ai-food-analyzer-header::after': {
    position: 'absolute',
    right: -45,
    bottom: -80,
    width: 210,
    height: 210,
    border: '1px solid rgba(255,255,255,0.14)',
    borderRadius: '50%',
    content: '""',
  },
  'body.experimental-popups .ai-food-analyzer-dialog .step-indicator': {
    padding: '10px 12px',
    borderRadius: '13px',
    background: '#f5f7ff',
  },
  'body.experimental-popups .ai-food-analyzer-dialog .step-number': {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
  },
  'body.experimental-popups .MuiDialog-root:has(.MuiTabs-root) .MuiDialog-paper': {
    background: '#ffffff',
  },
  'body.experimental-popups .week3-modal-content': {
    width: 'min(1180px, calc(100vw - 48px))',
    height: 'min(900px, calc(100dvh - 48px))',
    border: '1px solid rgba(226, 232, 240, 0.9)',
    borderRadius: '26px',
    backgroundColor: '#ffffff',
    boxShadow: '0 28px 90px rgba(15, 23, 42, 0.28)',
  },
  'body.experimental-popups .week3-modal-close': {
    top: '14px !important',
    right: '14px !important',
    border: '1px solid #e2e8f0',
    background: 'rgba(255,255,255,0.94)',
    boxShadow: '0 6px 16px rgba(15,23,42,0.09)',
  },
  'body.experimental-popups .recipes2-create-options > button': {
    minHeight: 92,
    background: '#ffffff',
    transition: '170ms ease',
  },
  'body.experimental-popups .recipes2-create-options > button:hover': {
    borderColor: '#a5b4fc',
    background: '#f5f7ff',
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 22px rgba(102,126,234,0.1)',
  },
  '@media (max-width: 700px)': {
    'body.experimental-popups .MuiDialog-container': {
      alignItems: 'flex-end',
    },
    'body.experimental-popups .MuiDialog-paper': {
      width: 'calc(100% - 12px) !important',
      maxWidth: 'none !important',
      maxHeight: 'calc(100dvh - 12px) !important',
      margin: '6px !important',
      borderRadius: '24px 24px 16px 16px !important',
    },
    'body.experimental-popups .MuiDialogTitle-root': {
      padding: '21px 18px 12px',
      fontSize: '1.05rem',
    },
    'body.experimental-popups .MuiDialogTitle-root::before': {
      right: 18,
      left: 18,
    },
    'body.experimental-popups .MuiDialogContent-root': {
      padding: '12px 18px 18px !important',
    },
    'body.experimental-popups .MuiDialogActions-root': {
      position: 'sticky',
      bottom: 0,
      zIndex: 2,
      padding: '11px 14px calc(11px + env(safe-area-inset-bottom)) !important',
      background: '#ffffff',
    },
    'body.experimental-popups .MuiDialogActions-root .MuiButton-root': {
      flex: 1,
      minHeight: 46,
    },
    'body.experimental-popups .ai-food-analyzer-header': {
      padding: '19px 18px !important',
    },
    'body.experimental-popups .ai-food-analyzer-header .MuiTypography-h5': {
      fontSize: '1.1rem',
    },
    'body.experimental-popups .ai-food-analyzer-header .MuiTypography-body2': {
      marginTop: 3,
      fontSize: '0.68rem',
    },
    'body.experimental-popups .week3-modal': {
      alignItems: 'flex-end',
    },
    'body.experimental-popups .week3-modal-content': {
      width: '100%',
      height: 'calc(100dvh - 10px)',
      borderRadius: '24px 24px 0 0',
    },
    'body.experimental-popups .recipes2-create-options': {
      gridTemplateColumns: '1fr',
    },
    'body.experimental-popups .recipes2-create-options > button': {
      minHeight: 68,
    },
  },
};

const ExperimentalPopupProvider = ({ children }) => {
  const baseTheme = useTheme();
  const popupTheme = useMemo(() => createTheme(baseTheme, {
    typography: { fontFamily: 'Quicksand, sans-serif' },
    shape: { borderRadius: 13 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 12, fontWeight: 800, textTransform: 'none' },
          containedPrimary: { background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
        },
      },
      MuiChip: { styleOverrides: { root: { borderRadius: 10, fontWeight: 700 } } },
      MuiTooltip: { styleOverrides: { tooltip: { borderRadius: 9, fontFamily: 'Quicksand, sans-serif' } } },
    },
  }), [baseTheme]);

  useEffect(() => {
    document.body.classList.add('experimental-popups');
    return () => document.body.classList.remove('experimental-popups');
  }, []);

  return (
    <ThemeProvider theme={popupTheme}>
      <GlobalStyles styles={globalPopupStyles} />
      {children}
    </ThemeProvider>
  );
};

export default ExperimentalPopupProvider;
